import { getLevelName } from "../../../utils/approvalsAccess";

export const hasAdmsScheduleTemplatesAccess = (userData) =>
  Boolean(
    userData?.access_levels?.some((level) => getLevelName(level) === "АДМС"),
  );
